// @flow

import { connect } from 'react-redux';
import SystemDownModal from './sysdown';

const mapState = ({ sam }) => ({
  sysdownmessage: sam.sysdownmessage,
});

const mapDispatch = {};

export default connect(
  mapState,
  mapDispatch,
)(SystemDownModal);
